/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base/';

const pathStrings = {
  16: [
    'M10.243 9.542a.667.667 0 00.666-.666v-4.99l1.69 1.69a.667.667 0 10.944-.943l-2.829-2.828a.667.667 0 00-.943 0L6.943 4.633a.667.667 0 10.943.943l1.69-1.69v4.99c0 .368.298.666.667.666zM5.667 6.367A.667.667 0 005 7.034v4.99l-1.69-1.69a.667.667 0 10-.943.942l2.828 2.829c.26.26.683.26.943 0l2.829-2.829a.667.667 0 10-.943-.943l-1.69 1.69v-4.99a.667.667 0 00-.667-.666z',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconSort = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconSort.displayName = 'IconSort';
